import partnersEn from "@/assets/seo/partners-share-en.jpg.asset.json";
import partnersBg from "@/assets/seo/partners-share-bg.jpg.asset.json";

const SITE_ORIGIN = "https://perceptica.com";

/** Paths (locale-agnostic) that have a dedicated hero screenshot in /public/og. */
const PAGE_OG: string[] = [
  "/about-us",
  "/contact-us",
  "/company-presentation",
  "/cookie-policy",
  "/media-analysis",
  "/media-analysis/competitive-intelligence",
  "/media-analysis/crisis-monitoring",
  "/media-analysis/employer-branding",
  "/media-analysis/market-research",
  "/media-analysis/reputation",
  "/media-analysis/faq",
  "/media-monitoring",
  "/media-monitoring/coverage",
  "/media-monitoring/platform",
  "/media-monitoring/platform/faq",
  "/industries",
  "/industries/automotive",
  "/industries/fintech",
  "/industries/fmcg",
  "/industries/pharma",
  "/industries/retail",
  "/who-we-help",
  "/who-we-help/brand-managers",
  "/who-we-help/pr-managers",
  "/who-we-help/pr-agency",
  "/who-we-help/media-agencies",
  "/who-we-help/employer-branding-experts",
  "/blog",
  "/reports",
  "/pricing",
  "/privacy-policy",
  "/request-a-demo",
  "/why-perceptica",
];

const SITE_DEFAULT = `${SITE_ORIGIN}/og-image.jpg`;

function fileFor(locale: "en" | "bg", path: string): string {
  const slug = path.replace(/^\//, "").replace(/\/$/, "").replace(/\//g, "-");
  return `${SITE_ORIGIN}/og/${locale === "bg" ? "bg-" : ""}${slug}.jpg`;
}

/**
 * Resolve the best OG image for a page. Falls back to the section default
 * (e.g. any /industries/* page without its own shot uses the industries hub
 * image) before ever falling back to the homepage hero.
 */
function ogImageFor(locale: "en" | "bg", path: string): string {
  const clean = path.replace(/\/$/, "") || "/";
  if (clean === "/partners") {
    return `${SITE_ORIGIN}${locale === "bg" ? partnersBg.url : partnersEn.url}`;
  }
  if (clean === "/") {
    return locale === "bg" ? `${SITE_ORIGIN}/og/bg-home.jpg` : SITE_DEFAULT;
  }
  if (PAGE_OG.includes(clean)) return fileFor(locale, clean);
  const section = PAGE_OG.filter((p) => p !== "/" && clean.startsWith(`${p}/`)).sort(
    (a, b) => b.length - a.length,
  )[0];
  if (section) return fileFor(locale, section);
  return SITE_DEFAULT;
}

/** Ready-to-spread meta entries for a route head(). */
export function ogImageMeta(locale: "en" | "bg", path: string, alt?: string) {
  const url = ogImageFor(locale, path);
  return [
    { property: "og:image", content: url },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    ...(alt ? [{ property: "og:image:alt", content: alt }] : []),
    { name: "twitter:image", content: url },
  ];
}
